import React from 'react';
import { ClipboardList, FileText, BarChart3, Settings, Zap } from 'lucide-react';
const services = [{
  icon: ClipboardList,
  title: 'Project & Operational Support',
  description: 'End-to-end assistance for ongoing operations and projects'
}, {
  icon: FileText,
  title: 'Documentation & Compliance',
  description: 'Structured management of documents, requirements, and approvals'
}, {
  icon: BarChart3,
  title: 'Technical & Analytical Support',
  description: 'Analysis, reporting, and structured decision support'
}, {
  icon: Settings,
  title: 'Coordination & Process Management',
  description: 'Clear communication and control across all involved parties'
}, {
  icon: Zap,
  title: 'Non-Standard Requests',
  description: 'Fast response to urgent or complex tasks that require attention'
}];
export function ServicesSection() {
  return <section id="about" className="w-full py-16 px-6 md:px-12 bg-white" data-id="element-238">
      <div className="max-w-7xl mx-auto" data-id="element-239">
        {/* About pill */}
        <div className="inline-block px-4 py-1.5 border border-gray-200 rounded-full mb-6" data-id="element-240">
          <span className="text-sm font-medium text-[var(--color-text-dark)]" data-id="element-241">
            About
          </span>
        </div>

        <div className="flex flex-col lg:flex-row gap-12" data-id="element-242">
          {/* Left side - Sticky on desktop */}
          <div className="lg:w-2/5 lg:sticky lg:top-24 lg:self-start" data-id="element-243">
            <h2 className="text-3xl md:text-4xl font-bold text-[var(--color-text-dark)] mb-6 leading-tight" data-id="element-244">
              How We Support Marine
              <br data-id="element-245" />& Industrial Operations
            </h2>
            <p className="text-[var(--color-text-light)] text-sm leading-relaxed mb-4" data-id="element-246">
              We support companies and operators by solving operational,
              technical, and organizational tasks.
            </p>
            <p className="text-[var(--color-text-light)] text-sm leading-relaxed" data-id="element-247">
              From documentation and coordination to complex, non-standard
              requests — ELVORA delivers clear and practical solutions
            </p>
          </div>

          {/* Right side - Scrollable grid */}
          <div className="lg:w-3/5" data-id="element-248">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-249">
              {services.map((service, index) => <div key={index} className="p-6 bg-white border border-gray-100 rounded-xl hover:border-gray-200 transition-colors" data-id="element-250">
                  <service.icon className="w-6 h-6 text-[var(--color-tan)] mb-4" strokeWidth={1.5} data-id="element-251" />
                  <h3 className="text-base font-semibold text-[var(--color-text-dark)] mb-2" data-id="element-252">
                    {service.title}
                  </h3>
                  <p className="text-sm text-[var(--color-text-light)]" data-id="element-253">
                    {service.description}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}